import { useEffect, useMemo, useState } from 'react'
import { AVISO_DIDATICO } from '../../../dominio/avisos'
import { camadasDaCena } from '../../../dominio/tabletop/camadas'
import { desserializarSessaoMesa } from '../../../dominio/tabletop/sessao'
import { Visualizador3D } from '../../../visualizacao3d/Visualizador3D'
import { useControleCamera } from '../../../visualizacao3d/camera/comandosCamera'
import { CenaMesa3D } from '../../../visualizacao3d/tabletop/CenaMesa3D'
import { volumeDaMesa } from './volume'
import { carregarMesa, CHAVE_MESA } from './persistencia'

export function ProjecaoMesa() {
  const [inicial] = useState(carregarMesa)
  const [sessao, setSessao] = useState(inicial.sessao)
  const [erro, setErro] = useState(inicial.erro)
  const camera = useControleCamera()
  const [ancora, setAncora] = useState(() =>
    volumeDaMesa(inicial.sessao.cena, []),
  )
  const camadas = useMemo(() => camadasDaCena(sessao.cena), [sessao.cena])
  const volume = useMemo(
    () => volumeDaMesa(sessao.cena, camadas, ancora),
    [sessao.cena, camadas, ancora],
  )
  useEffect(() => {
    const atualizar = (e: StorageEvent) => {
      if (e.key !== CHAVE_MESA || !e.newValue) return
      try {
        setSessao(desserializarSessaoMesa(e.newValue))
        setErro('')
      } catch {
        setErro(
          'A atualização da mesa é inválida. A última cena válida foi mantida.',
        )
      }
    }
    window.addEventListener('storage', atualizar)
    return () => window.removeEventListener('storage', atualizar)
  }, [])
  return (
    <main className="mesa-projecao" data-tema="escuro">
      <header>
        <h1>{sessao.cena.nome}</h1>
        <button
          className="btn-acao-cad"
          onClick={() => {
            setAncora(volumeDaMesa(sessao.cena, []))
            camera.executar('restaurar')
          }}
        >
          Enquadrar cena
        </button>
        <button
          className="btn-acao-cad"
          onClick={() => camera.executar('vistaSuperior')}
        >
          Vista superior
        </button>
      </header>
      <div className="mesa-projecao__cena">
        <Visualizador3D
          volume={volume}
          distanciaMaxima={24000}
          comandoCamera={camera.comando}
        >
          <CenaMesa3D cena={sessao.cena} camadas={camadas} mostrarCamadas />
        </Visualizador3D>
      </div>
      {erro && <p role="alert">{erro}</p>}
      {sessao.registros.length > 0 && (
        <p className="mesa-projecao__mensagem">
          {sessao.registros.at(-1)!.mensagem}
        </p>
      )}
      <footer role="note">{AVISO_DIDATICO}</footer>
    </main>
  )
}
